import { useState } from 'react'

import { resendConfirmEmail } from '../../api/auth'

import './style.css'

// Where the sign-up form keeps the new address, so "Check your email" can resend to it
export const PENDING_CONFIRM_EMAIL = 'pendingConfirmEmail'

export const rememberConfirmEmail = (email) => {
  try {
    window.sessionStorage.setItem(PENDING_CONFIRM_EMAIL, email)
  } catch (e) {
    // Browser storage is blocked (e.g. private mode): no resend button on that page
  }
}

export const pendingConfirmEmail = () => {
  try {
    return window.sessionStorage.getItem(PENDING_CONFIRM_EMAIL) || ''
  } catch (e) {
    return ''
  }
}

// "Didn't get it? Resend email", for people who can't sign in until they confirm
const ResendConfirmEmail = ({ email }) => {
  const [state, setState] = useState('') // '' | 'sending' | 'sent' | 'confirmed' | 'failed'

  if (!email) return null

  const resend = () => {
    setState('sending')
    resendConfirmEmail(email)
      .then(() => setState('sent'))
      // 10005: already confirmed
      .catch((error) => setState(error?.response?.data?.code === 10005 ? 'confirmed' : 'failed'))
  }

  if (state === 'sent') {
    return (
      <p className="resendConfirm" role="status">
        Sent! Check your inbox (and spam folder) for an email to <b>{email}</b> and click the link.
      </p>
    )
  }
  if (state === 'confirmed') {
    return (
      <p className="resendConfirm" role="status">
        Your email is already confirmed. You can sign in.
      </p>
    )
  }
  return (
    <p className="resendConfirm" aria-live="polite">
      {state === 'failed' ? 'That didn’t send. Please try again. ' : 'Didn’t get the email? '}
      <button
        type="button"
        className="resendConfirmButton"
        onClick={resend}
        disabled={state === 'sending'}
      >
        {state === 'sending' ? 'Sending…' : 'Resend email'}
      </button>
    </p>
  )
}

export default ResendConfirmEmail
